export default {
      id: "icon--explore-usage",
      viewBox: "0 0 24.4 24.4",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--explore-usage",
      toString: function () {
        return this.url;
      }
    }